import {defined, Logger, LogLevel} from "@variocube/driver-common";

export function setupLogging() {
    // When Chromium logs to stdout the additional parameters to the logging methods
    // of `console` are not included. We work around this behaviour by redefining
    // those methods.
    // We only do this when we run with a controller, meaning we are not in mock mode,
    // where likely someone runs Chromium with dev-tools.

    const params = new URLSearchParams(location.search);
    const isController = Boolean(params.get("controller"));

    if (isController) {
        const {log, info, error, debug, warn} = console;
        console.log = function () {
            log(stringify(arguments));
        };
        console.info = function () {
            info(stringify(arguments));
        };
        console.error = function () {
            error(stringify(arguments));
        };
        console.debug = function () {
            debug(stringify(arguments));
        };
        console.warn = function () {
            warn(stringify(arguments));
        };
    }

    //
    // Set up log level of Logger
    //
    Logger.setLogLevel(LogLevel.verbose);

    const logLevel = params.get("logLevel");
    if (logLevel) {
        const numericLevel = Object.entries(LogLevel)
            .filter(([key]) => key == logLevel)
            .map(([, value]) => value)
            .pop() as LogLevel | undefined;
        if (defined(numericLevel)) {
            Logger.setLogLevel(numericLevel);
        }
    }
}


function stringify(args: IArguments) {
    const stringArgs = [];
    for (let i = 0; i < args.length; i++) {
        stringArgs[i] = stringifyArg(args[i]);
    }
    return stringArgs.join(" ");
}

function stringifyArg(arg:any) {
    if (typeof arg == "string") {
        return arg;
    }
    else if (arg instanceof Error) {
        return (arg as Error).toString();
    }
    else {
        return JSON.stringify(arg);
    }
}